import React, { Component } from "react";
import Registry from "../../../Utils/Registry";

import OperationFleetUpdateItem from "./UpdateItem";
import ConfirmationModal from "../../ConfirmationModal";
import TYItem from "../../TYItem";
import {NotificationManager} from "react-notifications";

import Vars from "../../../Utils/Variables";


class OperationFleetItem extends Component{
    constructor(props){
        super(props);

        this.api = Registry.registered("api");

        this.toggle = this.toggle.bind(this);
        this.deleteVehicle = this.deleteVehicle.bind(this);
        this.toggleUpdate = this.toggleUpdate.bind(this);
        this.toggleConfirmation = this.toggleConfirmation.bind(this);

        this.state = {
            categories: [],
            dropdownOpen: false,
            confirmationOpen: false,
            updateOpen: false
        };
    }

    toggle(){
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }

    deleteVehicle(){
        this.api.del("/fleet/" + this.props.vehicle.id + "?type=business" + "&apply_to_rec=true")
            .then(() => {
                this.props.vehicleDeleted(this);
                NotificationManager.success("Véhicule supprimé !");
            })
            .catch(error => {
                NotificationManager.error("Une erreur est survenue");
            });
    }

    toggleConfirmation(){
        this.setState({confirmationOpen: !this.state.confirmationOpen});
    }

    toggleUpdate(){
        this.api.get("/fleet/categories?type=business")
            .then(results => {
                let categories = [];
                for (let cat of results.results)
                    categories.push(cat.category);

                this.setState({
                    categories: categories,
                    updateOpen: !this.state.updateOpen
                });
            });
    }

    render(){
        const { vehicle } = this.props;

        return (
            <div className="ty-list-item">
                <TYItem
                    icon="icon icon-car"
                    actions={[
                        { label: "Modifier", onclick: this.toggleUpdate},
                        { label: "Supprimer", onclick: this.toggleConfirmation}
                    ]}
                    flagColorCode={ vehicle.gas_color || "#c2cfd6"}
                >
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            { vehicle.description } - { vehicle.plate } - { vehicle.color }
                            <div className="f-12">
                                { Vars.energies[vehicle.energy_type].label } -&nbsp;
                                { 
                                    vehicle.energy_type === 0 ? 
                                        <span style={{color: vehicle.gas_color}}>{vehicle.gas_name}</span> 
                                        : Vars.energies[vehicle.energy_type].subTypes[vehicle.energy_sub_type].label 
                                }
                            </div>
                        </div>
                        <span className="blue_dark bold f-12">{ vehicle.category }</span>
                    </div>
                </TYItem>

                <OperationFleetUpdateItem
                    isOpen={this.state.updateOpen}
                    toggle={this.toggleUpdate}
                    onVehicleUpdated={this.props.vehicleUpdated}
                    categories={this.state.categories}
                    vehicle={vehicle}
                    gas_list={this.props.gas_list}
                />

                <ConfirmationModal
                    isOpen={this.state.confirmationOpen}
                    toggle={this.toggleConfirmation}
                    validate={this.deleteVehicle}
                    refuse={this.toggleConfirmation}
                    title="Supprimer le véhicule"
                    content={ <div>
                        &Ecirc;tes-vous s&ucirc;r de vouloir supprimer le v&eacute;hicule :<br />
                        <span className="bold">{ vehicle.description + " - " + vehicle.plate }</span> ?
                    </div>}
                />
            </div>
        );
    }
}

OperationFleetItem.defaultProps = {
    vehicle: {
        description: "",
        plate: "",
        color: "",
        category: "",
        gas_shorten: "",
        gas_color: "",
        gas_id: "",
        id: false
    },
    gas_list: [],
    vehicleDeleted: () => {},
    vehicleUpdated: () => {},
};

export default OperationFleetItem;



// WEBPACK FOOTER //
// ./src/components/Operations/Fleet/FleetItem.js